import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import RadioGroup from 'components/form/RadioGroup';

const YesNo = ({ question }) => {
  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={500}>
        {question.question_label}
      </Typography>
      <RadioGroup
        options={[
          { label: 'Yes', value: 'yes' },
          { label: 'No', value: 'no' },
        ]}
      />
    </Box>
  );
};

export default YesNo;
